<template lang="pug">
div
  b-row(v-show="isLoading")
    b-col
      b-card(class="py-5")
        loading(:active="true", :is-full-page="false", color="#498ceb")

  div(v-show="!isLoading")
    // Document metadata
    b-card
      b-row.align-items-center
        b-col(cols="auto")
          h4.mb-0 {{ document.nombre }}
        b-col.text-right.d-flex.flex-wrap.justify-content-end
          //- Editar datos / Subir nueva versión / Validar / Rechazar: se movieron a la
          //- columna Acciones del listado. Comentados (no borrados) por si se piden acá de nuevo.
          //- b-button.ml-1(
          //-   v-if="hasPermission('records-library', 'edit')",
          //-   size="sm",
          //-   variant="warning",
          //-   :to="{ name: 'organization-library-edit', params: { id: documentId } }"
          //- )
          //-   feather-icon(icon="EditIcon", class="mr-50")
          //-   | {{ $t('biblioteca.edit_metadata') }}
          //- b-button.ml-1(
          //-   v-if="document.activo && hasPermission('records-library', 'edit')",
          //-   size="sm",
          //-   variant="info",
          //-   @click="showUploadModal = true"
          //- )
          //-   feather-icon(icon="UploadIcon", class="mr-50")
          //-   | {{ $t('biblioteca.upload_new_version') }}
          //- b-button.ml-1(
          //-   v-if="canValidate",
          //-   size="sm",
          //-   variant="success",
          //-   @click="openValidateModal"
          //- )
          //-   feather-icon(icon="CheckCircleIcon", class="mr-50")
          //-   | {{ $t('biblioteca.validate') }}
          //- b-button.ml-1(
          //-   v-if="canValidate",
          //-   size="sm",
          //-   variant="danger",
          //-   @click="openRejectModal"
          //- )
          //-   feather-icon(icon="XCircleIcon", class="mr-50")
          //-   | {{ $t('biblioteca.reject') }}

      b-row.mt-0
        b-col
          b-badge.mr-1(:variant="getEstadoVariant(document.estado)")
            | {{ $t(`biblioteca.estado_${document.estado || 'pendiente'}`) }}
          b-badge.mr-1(variant="light-info")
            | v{{ document.versionActual || 1 }}
          b-badge(v-if="!document.activo", variant="light-secondary")
            | {{ $t('biblioteca.inactive') }}

      hr

      // Rejection reason display
      b-row(v-if="document.estado === 'rechazado' && document.motivoRechazo")
        b-col
          b-alert(show, variant="danger")
            strong {{ $t('biblioteca.rejection_reason') }}:
            |  {{ document.motivoRechazo }}

      b-row
        b-col(md="4")
          strong {{ $t('biblioteca.tipoDocumento') }}:
          p {{ document.tipoDocumento || '-' }}
        b-col(md="4")
          strong {{ $t('biblioteca.tematica') }}:
          p {{ document.tematica || '-' }}
        b-col(md="4")
          strong {{ $t('biblioteca.responsable') }}:
          p {{ document.responsableNombre || '-' }}

      b-row
        b-col(md="4")
          strong {{ $t('biblioteca.clientes') }}:
          p {{ clientesNombres || '-' }}
        b-col(md="4")
          strong {{ $t('biblioteca.registradoPor') }}:
          p {{ document.registradoPorNombre || '-' }}
        b-col(md="4")
          strong {{ $t('biblioteca.fechaRegistro') }}:
          p {{ formatDateDisplay(document.fechaRegistro) }}

      b-row
        b-col(md="4")
          strong {{ $t('biblioteca.fechaProximaRevision') }}:
          p {{ formatDateDisplay(document.fechaProximaRevision) }}
        b-col(md="8")
          strong {{ $t('biblioteca.observaciones') }}:
          p {{ document.observaciones || '-' }}

    // Version history
    b-card
      h5 {{ $t('biblioteca.version_history') }}
      b-table(
        :items="versionHistory",
        :fields="versionFields",
        hover,
        responsive,
        show-empty="",
        :empty-text="$t('biblioteca.no_versions')"
      )
        template(#cell(numeroVersion)="data")
          b-badge(variant="light-info") v{{ data.item.numeroVersion }}

        template(#cell(fechaSubida)="data")
          | {{ formatDateDisplay(data.item.fechaSubida) }}

        template(#cell(actions)="data")
          b-button(
            v-if="hasPermission('records-library', 'export')",
            size="sm",
            variant="outline-success",
            @click="handleDownloadVersion(data.item)"
          )
            feather-icon(icon="DownloadIcon", class="mr-25")
            | {{ $t('biblioteca.download') }}

    // Audit log (sistema unificado)
    audit-log-table(
      v-if="document && document.history"
      :history="document.history || []"
      :field-translations="{\
        nombre: $t('biblioteca.nombre'),\
        tipoDocumento: $t('biblioteca.tipoDocumento'),\
        tematica: $t('biblioteca.tematica'),\
        responsable: $t('label.responsible'),\
        clientes: $t('biblioteca.clientes'),\
        observaciones: $t('label.observations'),\
        fechaProximaRevision: $t('biblioteca.fechaProximaRevision')\
      }"
    )

    // Upload new version modal
    b-modal(
      v-model="showUploadModal",
      :title="$t('biblioteca.upload_new_version')",
      centered,
      no-close-on-backdrop,
      ok-variant="info",
      :ok-title="$t('biblioteca.upload')",
      :cancel-title="$t('message.cancel')",
      :ok-disabled="!newVersionFile.name || isUploading",
      @ok="handleUploadNewVersion"
    )
      p {{ $t('biblioteca.upload_version_description') }}
      b-form-group(:label="$t('label.document')")
        b-button(variant="info", @click="$refs.versionFileSelector.click()")
          feather-icon(icon="UploadIcon", class="mr-50")
          | {{ $t('biblioteca.select_file') }}
        input(
          ref="versionFileSelector",
          type="file",
          style="display: none",
          @change="onVersionFileSelected"
        )
        p.mt-1(v-if="newVersionFile.name")
          feather-icon(icon="FileIcon", class="mr-25")
          | {{ newVersionFile.name }}
      div(v-if="isUploading")
        loading(:active="true", :is-full-page="false", color="#498ceb")
        p.text-center {{ $t('biblioteca.uploading') }}

    // Validate modal
    b-modal(
      v-model="showValidateModal",
      :title="$t('biblioteca.validate_title')",
      centered,
      no-close-on-backdrop,
      ok-variant="success",
      :ok-title="$t('biblioteca.validate')",
      :cancel-title="$t('message.cancel')",
      :ok-disabled="isProcessing",
      @ok="handleValidate"
    )
      p {{ $t('biblioteca.validate_description') }}
      b-form-group(:label="$t('biblioteca.fechaProximaRevision')")
        b-form-datepicker(v-model="validateFechaRevision", :locale="locale", :placeholder="$t('biblioteca.placeholder_fecha')")
      div(v-if="isProcessing")
        loading(:active="true", :is-full-page="false", color="#498ceb")

    // Reject modal
    b-modal(
      v-model="showRejectModal",
      :title="$t('biblioteca.reject_title')",
      centered,
      no-close-on-backdrop,
      ok-variant="danger",
      :ok-title="$t('biblioteca.reject')",
      :cancel-title="$t('message.cancel')",
      :ok-disabled="!rejectMotivo.trim() || isProcessing",
      @ok="handleReject"
    )
      p {{ $t('biblioteca.reject_description') }}
      b-form-group(:label="$t('biblioteca.rejection_reason')")
        b-form-textarea(
          v-model="rejectMotivo",
          :placeholder="$t('biblioteca.placeholder_rejection_reason')",
          rows="3",
          required
        )
      b-form-group(:label="$t('biblioteca.fechaProximaRevision')")
        b-form-datepicker(v-model="rejectFechaRevision", :locale="locale", :placeholder="$t('biblioteca.placeholder_fecha')")
      div(v-if="isProcessing")
        loading(:active="true", :is-full-page="false", color="#498ceb")
        p.text-center {{ $t('message.loading') }}
</template>

<script>
import { ref, computed, onMounted } from '@vue/composition-api'
import { BBadge, BModal, BTable, BAlert } from 'bootstrap-vue'
import { useRouter } from '@core/utils/utils'
import store from '@/store'
import i18n from '@/libs/i18n'
import useNotifications from '@/composables/useNotifications'
import { useLambda } from '@/views/habit/awsLambda'
import useCommonLibrary from '../useCommonLibrary'
import AuditLogTable from '@/components/AuditLogTable.vue'
import { oid } from '@/helpers/mongoHelpers'
import { hasPermission } from '@/composables/usePermission'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'

export default {
  components: {
    BBadge,
    BModal,
    BTable,
    BAlert,
    AuditLogTable,
    Loading,
  },

  setup() {
    const { route } = useRouter()
    const { showSuccessMessage, showErrorMessage } = useNotifications()
    const { getItemsAggregate } = useLambda()
    const {
      collection, downloadVersion, uploadNewVersion,
      validateDocument, rejectDocument, canValidateDocument,
      sendNewVersionEmail, sendValidatedEmail, sendRejectedEmail,
    } = useCommonLibrary()
    const { default_language } = JSON.parse(localStorage.getItem('clientData') || '{}')
    const locale = default_language || 'es'
    const currentUserData = store.state?.userStore?.userData

    const documentId = route.value.params.id
    const document = ref({})
    const isLoading = ref(true)
    const showUploadModal = ref(false)
    const newVersionFile = ref({})
    const isUploading = ref(false)
    const clientesNombres = ref('')

    // Validation state
    const isProcessing = ref(false)
    const showValidateModal = ref(false)
    const showRejectModal = ref(false)
    const validateFechaRevision = ref('')
    const rejectMotivo = ref('')
    const rejectFechaRevision = ref('')

    const getDefaultFechaRevision = () => {
      const d = new Date()
      d.setMonth(d.getMonth() + 12)
      return d.toISOString().split('T')[0]
    }

    const openValidateModal = () => {
      validateFechaRevision.value = getDefaultFechaRevision()
      showValidateModal.value = true
    }

    const openRejectModal = () => {
      rejectFechaRevision.value = getDefaultFechaRevision()
      showRejectModal.value = true
    }

    // canValidateDocument vive en useCommonLibrary.js — compartida con el listado, para no
    // duplicar este cálculo (identidad por registro + hasPermission) en un tercer lugar.
    const canValidate = computed(() => canValidateDocument(document.value))

    const versionHistory = computed(() => {
      const history = document.value.historialVersiones || []
      return [...history].sort((a, b) => b.numeroVersion - a.numeroVersion)
    })

    const versionFields = [
      { key: 'numeroVersion', label: i18n.t('biblioteca.version') },
      { key: 'nombreArchivo', label: i18n.t('biblioteca.file_name') },
      { key: 'subidoPorNombre', label: i18n.t('biblioteca.uploaded_by') },
      { key: 'fechaSubida', label: i18n.t('biblioteca.upload_date') },
      { key: 'actions', label: i18n.t('message.tableHeader.actions') },
    ]

    const fetchDocument = async () => {
      isLoading.value = true
      try {
        const pipeline = [
          { $match: { _id: oid(documentId), client_id: oid(currentUserData.client.$oid) } },
          { $lookup: { from: 'worker', localField: 'responsable', foreignField: '_id', as: 'responsableData', pipeline: [{ $project: { name: 1 } }] } },
          { $lookup: { from: 'worker', localField: 'registradoPor', foreignField: '_id', as: 'registradoPorData', pipeline: [{ $project: { name: 1 } }] } },
          { $lookup: { from: 'company', localField: 'clientes', foreignField: '_id', as: 'clientesData', pipeline: [{ $project: { name: 1 } }] } },
          {
            $addFields: {
              responsableNombre: { $arrayElemAt: ['$responsableData.name', 0] },
              registradoPorNombre: { $arrayElemAt: ['$registradoPorData.name', 0] },
              _id: { $toString: '$_id' },
            },
          },
        ]

        const results = await getItemsAggregate({ collection, pipeline })
        const doc = results[0]

        if (doc) {
          clientesNombres.value = doc.clientesData?.map(c => c.name).join(', ') || ''

          // Resolve uploader names in version history
          const getId = (val) => val?.$oid || val?.toString() || ''
          if (doc.historialVersiones?.length) {
            const workerIds = [...new Set(doc.historialVersiones.map(v => getId(v.subidoPor)).filter(Boolean))]
            if (workerIds.length) {
              const workerPipeline = [
                { $match: { _id: { $in: workerIds.map(id => oid(id)) } } },
                { $project: { name: 1 } },
                { $addFields: { _id: { $toString: '$_id' } } },
              ]
              const workers = await getItemsAggregate({ collection: 'worker', pipeline: workerPipeline })
              const workerMap = {}
              workers.forEach(w => { workerMap[w._id] = w.name })
              doc.historialVersiones.forEach(v => {
                v.subidoPorNombre = workerMap[getId(v.subidoPor)] || ''
              })
            }
          }

          // Migrar auditLog → history para sistema unificado
          if (!doc.history) {
            doc.history = doc.auditLog || []
          }

          document.value = doc
        }
      } catch (error) {
        console.log(error)
        showErrorMessage(i18n.t('biblioteca.error_fetch'))
      } finally {
        isLoading.value = false
      }
    }

    const handleDownloadVersion = (version) => {
      if (!hasPermission('records-library', 'export')) {
        showErrorMessage(i18n.t('message.you_are_not_authorized'))
        return
      }
      downloadVersion(version.archivo, version.versionId)
    }

    const onVersionFileSelected = (e) => {
      newVersionFile.value = e.target.files[0]
    }

    const handleUploadNewVersion = async (bvModalEvt) => {
      bvModalEvt.preventDefault()
      if (!newVersionFile.value.name) return

      isUploading.value = true
      try {
        const newVersion = await uploadNewVersion(documentId, newVersionFile.value, document.value)
        showSuccessMessage(i18n.t('biblioteca.version_uploaded'))
        showUploadModal.value = false
        newVersionFile.value = {}

        // Send email to responsable about new version
        const responsableId = document.value.responsable?.$oid || document.value.responsable?.toString()
        if (responsableId) {
          sendNewVersionEmail(documentId, document.value, newVersion, responsableId)
        }

        await fetchDocument()
      } catch (error) {
        console.log(error)
        showErrorMessage(i18n.t('biblioteca.error_upload_version'))
      } finally {
        isUploading.value = false
      }
    }

    const handleValidate = async (bvModalEvt) => {
      bvModalEvt.preventDefault()
      isProcessing.value = true
      try {
        const fechaRevision = validateFechaRevision.value ? new Date(validateFechaRevision.value) : null
        await validateDocument(documentId, fechaRevision)
        showSuccessMessage(i18n.t('biblioteca.validated_success'))
        showValidateModal.value = false
        validateFechaRevision.value = ''

        // Send email to registradoPor
        sendValidatedEmail(documentId, document.value)

        await fetchDocument()
      } catch (error) {
        console.log(error)
        showErrorMessage(i18n.t('biblioteca.error_validate'))
      } finally {
        isProcessing.value = false
      }
    }

    const handleReject = async (bvModalEvt) => {
      bvModalEvt.preventDefault()
      if (!rejectMotivo.value.trim()) return
      isProcessing.value = true
      try {
        const fechaRevision = rejectFechaRevision.value ? new Date(rejectFechaRevision.value) : null
        await rejectDocument(documentId, rejectMotivo.value.trim(), fechaRevision)
        showSuccessMessage(i18n.t('biblioteca.rejected_success'))
        showRejectModal.value = false

        // Send email to registradoPor
        sendRejectedEmail(documentId, document.value, rejectMotivo.value.trim())

        rejectMotivo.value = ''
        rejectFechaRevision.value = ''
        await fetchDocument()
      } catch (error) {
        console.log(error)
        showErrorMessage(i18n.t('biblioteca.error_reject'))
      } finally {
        isProcessing.value = false
      }
    }

    const formatDateDisplay = (dateValue, includeTime = false) => {
      if (!dateValue) return '-'
      const raw = dateValue?.$date || dateValue
      const d = new Date(raw)
      if (includeTime) {
        return d.toLocaleString(`${default_language || 'es'}-CL`)
      }
      return d.toLocaleDateString(`${default_language || 'es'}-CL`, { timeZone: 'UTC' })
    }

    const getEstadoVariant = (estado) => {
      const variants = {
        pendiente: 'light-warning',
        validado: 'light-success',
        rechazado: 'light-danger',
        vencido: 'light-secondary',
      }
      return variants[estado] || 'light-info'
    }

    onMounted(() => {
      fetchDocument()
    })

    return {
      documentId,
      document,
      isLoading,
      showUploadModal,
      newVersionFile,
      isUploading,
      versionHistory,
      versionFields,
      clientesNombres,
      handleDownloadVersion,
      onVersionFileSelected,
      handleUploadNewVersion,
      handleValidate,
      handleReject,
      canValidate,
      isProcessing,
      openValidateModal,
      openRejectModal,
      showValidateModal,
      showRejectModal,
      validateFechaRevision,
      rejectMotivo,
      rejectFechaRevision,
      locale,
      formatDateDisplay,
      getEstadoVariant,
      hasPermission,
    }
  },
}
</script>
